import { t as e } from "../utils-DiFe-_ei.js";
import * as t from "react";
import { jsx as n } from "react/jsx-runtime";
//#region src/foundations/textarea/textarea.tsx
var r = t.forwardRef(({ className: t, ...r }, i) => /* @__PURE__ */ n("textarea", {
	className: e("flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", t),
	ref: i,
	...r
}));
r.displayName = "Textarea";
//#endregion
export { r as Textarea };

//# sourceMappingURL=textarea.js.map